import { rule, isValidEmail, required, maxLength } from 'components/Shared/Form/rules';
import { isValidZipcode } from 'components/Shared/ZipCodeInput/themes/BGH/validation';
import { rm } from 'utils';
import { isValidPhoneNumber } from 'views/CheckoutPage/validation';

const PASSWORD_MIN_LENGTH = 8;

export const email = rule(() => rm('customerservice_shared_error_email'), isValidEmail);
export const phone = rule(() => rm('sip_error_mobile_number'), isValidPhoneNumber);
export const password = rule(
  () => rm('customerpage_register_error_missing_password'),
  required,
  maxLength(PASSWORD_MIN_LENGTH)
);
export const zipCode = rule(() => rm('sip_error_zip_code'), isValidZipcode);
export const orderNumber = rule(() => rm('customerpage_order_add_ordernumber_error'), required);

export const name = rule(() => rm('customerpage_form_name_error'), required);
export const street = rule(() => rm('customerpage_form_street_error'), required);
export const city = rule(() => rm('customerpage_form_city_error'), required);
